module.exports = __webpack_public_path__ + "static/18-ai-in-the-built-environment-4-key-areas-it-will-impact-27d689094200af26af061d3716b394d8.jpg";